/**
 * Extract the raw text content from an input html / xml format.
 */
export function getTextContent(html: string): string {
    return html
        .replace(/\<[^\>]*\>/g, "")
        .replace(/\s+/g, " ");
}
